import { forwardRef } from 'react';

import './styles.scss';

type BacktestingCheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
};

export const BacktestingCheckbox = forwardRef<HTMLInputElement, BacktestingCheckboxProps>(
  ({ className = '', label, ...props }, ref) => (
    <label className={`backtesting-checkbox-wrapper ${className}`.trim()}>
      <input type="checkbox" ref={ref} className="backtesting-checkbox" {...props} />
      {label && <span className="backtesting-checkbox-label">{label}</span>}
    </label>
  ),
);

BacktestingCheckbox.displayName = 'BacktestingCheckbox';
